


































import { Component, Vue, Prop } from 'vue-property-decorator'
import { PepercentDto } from '../model/index'
@Component
export default class GlobalSetting extends Vue {
  @(Prop({
    type: Object,
    default: () => {
      return { direct: 0, indirect: 0 }
    }
  })!)
  data: PepercentDto
  @(Prop({ type: Number, default: 1 })!) level: number
}
